const FEEDBACK_PLOT_RECOMMENDATION = "trama-ia";

export const HOTJAR_FEEDBACKS = { FEEDBACK_PLOT_RECOMMENDATION };
